export default {
  title: 'Módulos vinculados',
  description: 'Escolha quais funcionalidades fazem parte de cada aplicação disponibilizada aos clientes.',
  form:{
    title: 'Vincular Módulo'
  },
  labels: {
    new: 'Novo Vínculo',
  },
  fields: {
    name: 'Módulo',
  }
};
